import React, { FC } from "react";
import { FormLabel as MuiFormLabel } from "@mui/material";

type Props = React.ComponentProps<typeof MuiFormLabel>;

const FormLabel: FC<Props> = (props) => {
    return <MuiFormLabel {...props}/>
}

export default FormLabel;